import store from '@/store'
import NotificationApi from '@/api/notifications'
import Auth from '../auth'

export default{
    get notifications(){
        return store.state.notifications.notifications
    },
    set notifications(value){
        store.commit('notifications/setNotifications', value)
    },
    getNotifications(){
        if(Auth.isAuthenticated){
            NotificationApi.GetLast10().then(res=>{
                this.notifications = res.data.Data
            })
        }
    }
}